import { CapitalRequest } from './capitalRequest';
import { EntityTypes } from './enums/entityTypes';

export interface CapitalRequestMatch {
  requestId: string;
  matchId: string;
  orgId: string;
  supplierOrgId: string;
  entityType: EntityTypes.capitalMatch;
  orgName: string;
  matchConfidence: number;
  status: string;
  created: number;
  lastUpdated: number;
  answers?: {
    [key: string]: string;
  };
  capitalRequest?: CapitalRequest;
}

export interface CreateCapitalRequestMatchItem {
  requestId: string;
  orgId: string;
  supplierOrgId: string;
  orgName: string;
  matchConfidence: number;
}
